import React from 'react'
import {Button, ButtonGroup, Dropdown} from 'react-bootstrap'
import ExlMailCalendarIcons from '../../../../components/exl/icons/ExlMailCalendarIcons';
import { useTranslation } from 'react-i18next';
import { EMAIL_NOTIFICATIONS_FALSE, EMAIL_NOTIFICATIONS_TRUE, TEACHER_DETAILS_HEADER_EDIT_TEACHER_LABEL, TEACHER_DETAILS_HEADER_DELETE_CV_LABEL, TEACHER_DETAILS_HEADER_DELETE_TEACHER_LABEL, TEACHER_DETAILS_HEADER_TEACHER_LABEL, TEACHER_DETAILS_HEADER_UPLOAD_CV_LABEL } from '../../../../i18n/keyConstants';
import ProfileImage from '../../../../components/ProfileImage';

const TeacherActions = ({
    teacher,
    teacherUser,
    refreshTeacherData,
    setEditTeacherModalOpen,
    setDeleteTeacherModalOpen,
    setUploadCVModalOpen,
    setDeleteTeacherCVModalOpen
}) => {
    const { t } = useTranslation(['teacherDetailsHeader', 'shared']);
    return (
        <div className='flex-wrap' style={{display: "flex", gap: "8px",}}>
                {teacherUser.editPermission && (
                <>
                    <ExlMailCalendarIcons 
                        sendEmailNotifications={teacher.receiveEmailNotifications}
                        trueText={t(EMAIL_NOTIFICATIONS_TRUE, {ns: 'shared'})} 
                        falseText={t(EMAIL_NOTIFICATIONS_FALSE, {ns: 'shared'})} 
                      />
                    <Dropdown as={ButtonGroup}>
                        <Button variant="info" onClick={() => setEditTeacherModalOpen(true)}>{t(TEACHER_DETAILS_HEADER_EDIT_TEACHER_LABEL)}</Button>
                        <Dropdown.Toggle split variant="info" id="dropdown-split-basic" />
                        <Dropdown.Menu>
                            <Dropdown.Item
                                eventKey="1"
                                onClick={() => setUploadCVModalOpen(true)}
                            >
                                {t(TEACHER_DETAILS_HEADER_UPLOAD_CV_LABEL)}
                            </Dropdown.Item>
                            <Dropdown.Item
                                eventKey="2"
                                onClick={() => setDeleteTeacherCVModalOpen(true)}
                            >
                                {t(TEACHER_DETAILS_HEADER_DELETE_CV_LABEL) }
                            </Dropdown.Item>
                            <Dropdown.Item
                                eventKey="3"
                                onClick={() => setDeleteTeacherModalOpen(true)}
                            >
                                {t(TEACHER_DETAILS_HEADER_DELETE_TEACHER_LABEL) }
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </>
                )}
        </div>
        )
    }

export default function TeacherDetailsHeader({
    teacher,
    teacherUser,
    refreshTeacherData,
    setEditTeacherModalOpen,
    setDeleteTeacherModalOpen,
    setUploadCVModalOpen,
    setDeleteTeacherCVModalOpen
}) {
    const { t } = useTranslation(['teacherDetailsHeader', 'shared']);
    return (
        <div style={{
            display: "flex",
            justifyContent: "space-between",
            position: "sticky",
            top: 0,
            paddingBottom: 24,
            zIndex: 2,
            flexWrap: "wrap",
          }}>
     

            <div className='card-body' style={{ padding: 10, backgroundColor:"#f5f5f5" }}>
                    <div className='card-profile-img text-center margin-bottom-10px margin-top-10px'>
                        <img 
                        className='margin-none' 
                        src={teacher.photo || ProfileImage} 
                        alt='user icon'
                        onError={(e) => { e.target.onerror = null; e.target.src=ProfileImage }} />
                    </div>
                
                <div>
                    <h3
                        style={{
                        textAlign: "center",
                        color: "black",
                        marginBottom: 0
                        }}
                        className="text-center"
                    >
                        {teacher.name}
                    </h3>

                    
                </div>
                <div className="row justify-content-center">

                    <p
                        style={{
                            textAlign: "center",
                            color: "black",
                            marginBottom: 0,
                        }}
                        className="col-4"
                    >
                        {t(TEACHER_DETAILS_HEADER_TEACHER_LABEL) }
                    </p>

                </div>
                <div className='d-flex justify-content-end'>
                    <div className="">
                        <TeacherActions
                            teacher={teacher}
                            teacherUser={teacherUser}
                            refreshTeacherData={refreshTeacherData}
                            setEditTeacherModalOpen={setEditTeacherModalOpen}
                            setDeleteTeacherModalOpen={setDeleteTeacherModalOpen}
                            setUploadCVModalOpen={setUploadCVModalOpen}
                            setDeleteTeacherCVModalOpen={setDeleteTeacherCVModalOpen}
                        />
                    </div>
                </div>

            </div>
        </div>
    )
}